import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-fill text-foreground-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-950">
                木瓜影院
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md">
              木瓜影院是您的首选在线观影平台，汇聚海量高清电影、电视剧、综艺、动漫资源。无需注册，永久免费，让您随时随地享受极致观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-categories" className="cursor-pointer">影片分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-links" className="cursor-pointer">快捷链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/dianying" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  热门电影
                </Link>
              </li>
              <li>
                <Link to="/category/dianshiju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  最新剧集
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 木瓜影院 muguayingyuan.com. 本站所有内容均来自网络，仅供学习和交流。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
                使用条款
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}